import { Talent } from '../types/talent';

export const mockTalents: Talent[] = [
  {
    id: '1',
    name: 'Sarah Chen',
    jobTitle: 'Senior Software Engineer',
    jobLevel: 'L6',
    department: 'Engineering',
    location: 'San Francisco, CA',
    experience: '8 years',
    skills: ['React', 'TypeScript', 'Node.js', 'AWS', 'GraphQL'],
    status: 'Above level',
    lastUpdated: '2024-01-15',
    rating: 4.8,
    summary: 'Experienced full-stack engineer with expertise in modern web technologies and cloud architecture.'
  },
  {
    id: '2',
    name: 'Marcus Johnson',
    jobTitle: 'Product Manager',
    jobLevel: 'L5',
    department: 'Product',
    location: 'New York, NY',
    experience: '6 years',
    skills: ['Product Strategy', 'Data Analysis', 'User Research', 'Agile', 'Roadmapping'],
    status: 'Performing at level',
    lastUpdated: '2024-01-14',
    rating: 4.6,
    summary: 'Strategic product leader with a track record of launching successful consumer products.'
  },
  {
    id: '3',
    name: 'Emily Rodriguez',
    jobTitle: 'UX Designer',
    jobLevel: 'L4',
    department: 'Design',
    location: 'Austin, TX',
    experience: '5 years',
    skills: ['Figma', 'User Research', 'Prototyping', 'Design Systems', 'Accessibility'],
    status: 'Above level',
    lastUpdated: '2024-01-13',
    rating: 4.7,
    summary: 'Creative designer focused on user-centered design and accessibility best practices.'
  },
  {
    id: '4',
    name: 'David Kim',
    jobTitle: 'Data Scientist',
    jobLevel: 'L5',
    department: 'Data',
    location: 'Seattle, WA',
    experience: '7 years',
    skills: ['Python', 'Machine Learning', 'SQL', 'TensorFlow', 'Statistics'],
    status: 'Above level',
    lastUpdated: '2024-01-12',
    rating: 4.9,
    summary: 'Data scientist specializing in machine learning and predictive analytics.'
  },
  {
    id: '5',
    name: 'Lisa Wang',
    jobTitle: 'Engineering Manager',
    jobLevel: 'L7',
    department: 'Engineering',
    location: 'San Francisco, CA',
    experience: '12 years',
    skills: ['Team Leadership', 'System Architecture', 'Java', 'Microservices', 'DevOps'],
    status: 'Above level',
    lastUpdated: '2024-01-11',
    rating: 4.8,
    summary: 'Experienced engineering leader with expertise in scaling teams and distributed systems.'
  },
  {
    id: '6',
    name: 'Alex Thompson',
    jobTitle: 'Marketing Specialist',
    jobLevel: 'L3',
    department: 'Marketing',
    location: 'Chicago, IL',
    experience: '3 years',
    skills: ['Digital Marketing', 'Content Strategy', 'SEO', 'Analytics', 'Social Media'],
    status: 'Below level',
    lastUpdated: '2024-01-10',
    rating: 4.3,
    summary: 'Digital marketing specialist with expertise in content strategy and performance marketing.'
  },
  {
    id: '7',
    name: 'Jennifer Lee',
    jobTitle: 'Sales Director',
    jobLevel: 'L6',
    department: 'Sales',
    location: 'Boston, MA',
    experience: '10 years',
    skills: ['Sales Strategy', 'Team Management', 'CRM', 'Negotiation', 'Customer Relations'],
    status: 'Performing at level',
    lastUpdated: '2024-01-09',
    rating: 4.7,
    summary: 'Results-driven sales leader with a proven track record of exceeding revenue targets.'
  },
  {
    id: '8',
    name: 'Michael Brown',
    jobTitle: 'DevOps Engineer',
    jobLevel: 'L5',
    department: 'Engineering',
    location: 'Denver, CO',
    experience: '6 years',
    skills: ['Kubernetes', 'Docker', 'AWS', 'Terraform', 'CI/CD'],
    status: 'Performing at level',
    lastUpdated: '2024-01-08',
    rating: 4.6,
    summary: 'DevOps engineer focused on infrastructure automation and cloud-native technologies.'
  },
  {
    id: '9',
    name: 'Rachel Green',
    jobTitle: 'HR Business Partner',
    jobLevel: 'L4',
    department: 'Human Resources',
    location: 'Los Angeles, CA',
    experience: '5 years',
    skills: ['Talent Acquisition', 'Performance Management', 'Employee Relations', 'Compensation', 'Training'],
    status: 'Performing at level',
    lastUpdated: '2024-01-07',
    rating: 4.5,
    summary: 'Strategic HR partner focused on talent development and organizational effectiveness.'
  },
  {
    id: '10',
    name: 'James Wilson',
    jobTitle: 'Security Engineer',
    jobLevel: 'L5',
    department: 'Security',
    location: 'Washington, DC',
    experience: '8 years',
    skills: ['Cybersecurity', 'Penetration Testing', 'Risk Assessment', 'Compliance', 'Incident Response'],
    status: 'Above level',
    lastUpdated: '2024-01-06',
    rating: 4.8,
    summary: 'Cybersecurity expert with extensive experience in threat detection and incident response.'
  }
];

export const departments = [
  'Engineering',
  'Product',
  'Design',
  'Data',
  'Marketing',
  'Sales',
  'Human Resources',
  'Security'
];

export const jobLevels = [
  'L3',
  'L4',
  'L5',
  'L6',
  'L7'
];

export const locations = [
  'San Francisco, CA',
  'New York, NY',
  'Austin, TX',
  'Seattle, WA',
  'Chicago, IL',
  'Boston, MA',
  'Denver, CO',
  'Los Angeles, CA',
  'Washington, DC'
];